<style lang="scss" scoped>


</style>

<template>
    <Alert v-if="isWaterPointWell" type="danger" :show="isAlert" :timeout="timeout" >
        <template v-slot:title>Grundwasserstandsmessung in Ruhe notwendig</template>
        <template v-if="isOverMaxStillWaterLevelDocumentation">
            <router-link class="text-reset" to="/level?action=newlevel" @click="closeModal">
                Für den gewählten Brunnen liegt die letzte Dokumentation des Ruhewasserstands länger als 
                {{ wellStillWaterLevelFrequency }} Tage zurück. Diese ist in diesem Zeitraum mindestens 
                ein mal durchzuführen. Zur Messung des Ruhewassestand geht es hier.
            </router-link> 
        </template>
        <template v-else-if="lastStillWaterLevelDocumentation === null">
            <router-link class="text-reset" to="/level?action=newlevel" @click="closeModal">
                Für den ausgewählten Brunnen wurde im Schlagjahr noch keine Dokumentation des Grundwasserstands in Ruhe vorgenommen.
                Die Dokumentation ist regelmäßig im Abstand von max. {{ wellStillWaterLevelFrequency }} Tagen durchzuführen. Zur Dokumentation
                geht es hier.
            </router-link> 
        </template>
    </Alert>
</template>

<script>

import Alert from '@/components/Alert.vue';
import * as dayjs from 'dayjs';

export default {
    name: 'WaterPointWellAlert',
    components: {
        Alert
    },
    inject: [
        'state',
        'config'
    ],
    props: {
        waterPointId: {
          type: Number,
          default: null
        },
        timeout: {
            type: Number,
            default: 0
        }
    },
    data: function () {
        return {
            
        }
    },
    computed: { 
        waterPoint: function () {
            const waterPoint = this.state.actions.waterPoint.get(this.waterPointId);
            return waterPoint ? waterPoint: {}; 
        },
        isWaterPointWell: function () {
            return this.waterPoint && this.waterPoint.typ === 'brunnen';
        },
        wellStillWaterLevelFrequency: function () {
            return this.config.logic.stillWaterLevelFrequency;
        },
        isAlert: function () {
            
            if (this.waterPoint === null) {
                return false;
            }
        
            if (this.waterPoint.typ !== 'brunnen') {
                return false;
            }
            
            if (this.waterPoint.lastStillWaterLevel === false) {
                return false;
            }
            
            if (this.state.profile && this.state.profile.year !== dayjs().year()) {
                return false;
            }
            
            if (this.waterPoint.lastStillWaterLevel && dayjs(this.waterPoint.lastStillWaterLevel).year() !== dayjs().year()) {
                return false;
            }
            
            if (this.waterPoint.lastStillWaterLevel === null) {
                return true;
            }
            
            if (this.isOverMaxStillWaterLevelDocumentation) {
                return true;
            }
            
            return false;
        },
        lastStillWaterLevelDocumentation: function () {
            if (this.waterPoint && this.waterPoint.lastStillWaterLevel) {
                return dayjs().diff(this.waterPoint.lastStillWaterLevel, 'days');
            }
            
            return null;
        },
        isOverMaxStillWaterLevelDocumentation: function () {           
            if (this.lastStillWaterLevelDocumentation && this.lastStillWaterLevelDocumentation > this.wellStillWaterLevelFrequency) {
                return true;
            }
            
            return false;
        }
    },
    methods: {
        closeModal: function () {
            if (this.$parent.closeModal) {
                this.$parent.closeModal();    
            }
        }
    },
    watch: {
        'state.profile.year': function (new_value, old_value) {
            if (new_value !== old_value && this.waterPoint) {
                this.waterPoint.lastStillWaterLevel = false; 
            }
        }
    },
    mounted: function () {
    
    }
}

</script>